import { StorageContainer } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface DeactivateStorageContainerMutation {
  deactivateStorageContainer: StorageContainer
}

export interface DeactivateStorageContainerVariables {
  id: GQL_ID
}

export const GQL_MUTATION_DEACTIVATE_STORAGE_CONTAINER = gql`
  mutation deactivateStorageContainer($id: ID!) {
    deactivateStorageContainer(id: $id) {
      id
      container_id
      size
      type
      description
      is_active
      created_at
      updated_at
      displayName
    }
  }
`

export function useDeactivateStorageContainer () {
  return useMutation<DeactivateStorageContainerMutation, DeactivateStorageContainerVariables>(
    GQL_MUTATION_DEACTIVATE_STORAGE_CONTAINER
  )
}
